
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowLeft, Settings, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ComplianceHeaderProps {
  refreshData: () => void;
  isRefreshing: boolean;
}

export const ComplianceHeader: React.FC<ComplianceHeaderProps> = ({ 
  refreshData, 
  isRefreshing 
}) => {
  const navigate = useNavigate();

  const handleBackNavigation = () => {
    const lastActiveView = localStorage.getItem('lastActiveView') || 'chat';
    navigate('/dashboard', { state: { activeView: lastActiveView } });
  };

  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBackNavigation}
          className="rounded-full h-8 w-8"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Compliance Dashboard</h1>
          <p className="text-gray-500 mt-1">
            Monitor communications, manage risk, and ensure regulatory compliance
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={refreshData} disabled={isRefreshing} className="flex items-center gap-2">
          <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          {isRefreshing ? 'Refreshing...' : 'Refresh Data'}
        </Button>
        <Button variant="outline" className="flex items-center gap-2">
          <Settings className="h-4 w-4" />
          Settings
        </Button>
      </div>
    </div>
  );
};
